"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionResponseToJSON = exports.PositionResponseFromJSONTyped = exports.PositionResponseFromJSON = exports.instanceOfPositionResponse = void 0;
var SignalMapSetting_1 = require("./SignalMapSetting");
/**
 * Check if a given object implements the PositionResponse interface.
 */
function instanceOfPositionResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "latitude" in value;
    isInstance = isInstance && "longitude" in value;
    isInstance = isInstance && "memberid" in value;
    isInstance = isInstance && "timestamp" in value;
    isInstance = isInstance && "image" in value;
    isInstance = isInstance && "online" in value;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "battery_level" in value;
    isInstance = isInstance && "on_the_water" in value;
    isInstance = isInstance && "distance_from_member" in value;
    isInstance = isInstance && "signal_map_setting" in value;
    isInstance = isInstance && "subscribed" in value;
    return isInstance;
}
exports.instanceOfPositionResponse = instanceOfPositionResponse;
function PositionResponseFromJSON(json) {
    return PositionResponseFromJSONTyped(json, false);
}
exports.PositionResponseFromJSON = PositionResponseFromJSON;
function PositionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'memberid': json['memberid'],
        'timestamp': json['timestamp'],
        'image': json['image'],
        'online': json['online'],
        'username': json['username'],
        'battery_level': json['battery_level'],
        'on_the_water': json['on_the_water'],
        'distance_from_member': json['distance_from_member'],
        'signal_map_setting': (0, SignalMapSetting_1.SignalMapSettingFromJSON)(json['signal_map_setting']),
        'subscribed': json['subscribed'],
    };
}
exports.PositionResponseFromJSONTyped = PositionResponseFromJSONTyped;
function PositionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'memberid': value.memberid,
        'timestamp': value.timestamp,
        'image': value.image,
        'online': value.online,
        'username': value.username,
        'battery_level': value.battery_level,
        'on_the_water': value.on_the_water,
        'distance_from_member': value.distance_from_member,
        'signal_map_setting': (0, SignalMapSetting_1.SignalMapSettingToJSON)(value.signal_map_setting),
        'subscribed': value.subscribed,
    };
}
exports.PositionResponseToJSON = PositionResponseToJSON;
